import React from 'react';

export function SettingsDataInputTab({ p }) {
    return (
                <div className="settings-tab-content">
                    {p.dataSettingsLoading && (
                        <div className="loading">
                            <i className="fas fa-spinner fa-spin"></i> Loading data settings...
                        </div>
                    )}

                    {/* Data Definitions Section */}
                    <div className="settings-category" id="data-definitions-category">
                        <h3>
                            <i className="fas fa-table"></i> Data Definitions
                            <span className="badge badge-config">CONFIG</span>
                        </h3>
                        <p className="section-description">
                            Manage data entry type definitions for ingestion. Each entry defines a column that will be
                            used when processing documents.
                        </p>

                        {p.hasDataEntryChanges() && (
                            <div className="alert alert-warning">
                                <i className="fas fa-exclamation-triangle"></i>
                                <div>
                                    <strong>Warning:</strong> You have pending changes that have not been committed to
                                    the database.
                                    <ul style={{marginTop: '10px', marginBottom: '10px'}}>
                                        {p.pendingChanges.creates.length > 0 && (
                                            <li>{p.pendingChanges.creates.length} new
                                                entr{p.pendingChanges.creates.length === 1 ? 'y' : 'ies'} to create</li>
                                        )}
                                        {p.pendingChanges.updates.length > 0 && (
                                            <li>{p.pendingChanges.updates.length} entr{p.pendingChanges.updates.length === 1 ? 'y' : 'ies'} to
                                                update</li>
                                        )}
                                        {p.pendingChanges.deletes.length > 0 && (
                                            <li>{p.pendingChanges.deletes.length} entr{p.pendingChanges.deletes.length === 1 ? 'y' : 'ies'} to
                                                delete</li>
                                        )}
                                    </ul>
                                    <strong>If you change the schema, you will need to reingest the data.</strong>
                                </div>
                            </div>
                        )}

                        {!p.hasDataEntryChanges() && (
                            <div className="alert alert-info">
                                <i className="fas fa-info-circle"></i>
                                <strong>Note:</strong> Changes are made locally first. Click "Update Database" to commit
                                all changes. If you change the schema, you will need to reingest the data.
                            </div>
                        )}

                        {p.dataEntriesLoading ? (
                            <div className="loading">
                                <i className="fas fa-spinner fa-spin"></i> Loading data definitions...
                            </div>
                        ) : (
                            <>
                                <div className="data-entries-actions">
                                    <button
                                        className="btn btn-primary"
                                        onClick={p.handleAddDataEntry}
                                        disabled={p.dataSettingsLoading || p.saving || p.dataEntriesLoading}
                                    >
                                        <i className="fas fa-plus"></i> Add Data Entry Type
                                    </button>
                                </div>

                                {p.dataEntries.length === 0 ? (
                                    <div className="empty-state">
                                        <i className="fas fa-inbox"></i>
                                        <p>No data entry types defined yet. Click "Add Data Entry Type" to create
                                            one.</p>
                                    </div>
                                ) : (
                                    <div className="data-entries-list">
                                        {p.dataEntries.map((entry) => {
                                            const isPendingCreate = entry.tempId !== undefined;
                                            const isPendingUpdate = p.pendingChanges.updates.some(u => u.id === entry.id);
                                            const isPendingDelete = p.pendingChanges.deletes.includes(entry.id);

                                            return (
                                                <div key={entry.id || entry.tempId}
                                                     className={`data-entry-card ${isPendingCreate ? 'pending-create' : ''} ${isPendingUpdate ? 'pending-update' : ''} ${isPendingDelete ? 'pending-delete' : ''}`}>
                                                    {isPendingCreate &&
                                                        <span className="pending-badge create">New (Pending)</span>}
                                                    {isPendingUpdate && <span className="pending-badge update">Modified (Pending)</span>}
                                                    {isPendingDelete &&
                                                        <span className="pending-badge delete">Deleted (Pending)</span>}
                                                    <div className="data-entry-header">
                                                        <h4>{entry.visible_string}</h4>
                                                        <span className="data-entry-meta">
                        Column: <code>{entry.column_name}</code> | Schema v{entry.schema_version}
                      </span>
                                                    </div>
                                                    <div className="data-entry-actions">
                                                        {!isPendingDelete && (
                                                            <button
                                                                className="btn btn-primary btn-sm"
                                                                onClick={() => p.handleEditDataEntry(entry)}
                                                                disabled={p.dataSettingsLoading || p.saving || p.dataEntriesLoading}
                                                            >
                                                                <i className="fas fa-edit"></i> Edit
                                                            </button>
                                                        )}
                                                        <button
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => p.handleDeleteDataEntryClick(entry.id || entry.tempId)}
                                                            disabled={p.dataSettingsLoading || p.saving || p.dataEntriesLoading}
                                                        >
                                                            <i className="fas fa-trash"></i> Delete
                                                        </button>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </>
                        )}
                    </div>

                    {/* Data Entry Editor Modal */}

                    {/* Data Entry Editor Modal */}
                    {p.showDataEntryModal && (
                        <div className="modal show">
                            <div className="modal-content large">
                                <div className="modal-header">
                                    <h2 className="modal-title">
                                        {p.editingDataEntry ? 'Edit Data Entry Type' : 'New Data Entry Type'}
                                    </h2>
                                    <span className="close" onClick={() => p.setShowDataEntryModal(false)}>&times;</span>
                                </div>
                                <div className="modal-body">
                                    <div className="alert alert-warning">
                                        <i className="fas fa-exclamation-triangle"></i>
                                        <strong>Warning:</strong> Changes are saved locally. Click "Update Database" to
                                        commit. If you change the schema, you will need to reingest the data.
                                    </div>

                                    <form>
                                        <div className="form-group">
                                            <label htmlFor="visibleString">Visible String: <span
                                                className="required">*</span></label>
                                            <input
                                                type="text"
                                                id="visibleString"
                                                value={p.dataEntryForm.visible_string}
                                                onChange={(e) => p.setDataEntryForm(prev => ({
                                                    ...prev,
                                                    visible_string: e.target.value
                                                }))}
                                                placeholder="e.g., Blog Post, Article, Document"
                                                required
                                            />
                                            <small>Human-readable name for this data entry type</small>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="columnName">Column Name: <span className="required">*</span></label>
                                            <input
                                                type="text"
                                                id="columnName"
                                                value={p.dataEntryForm.column_name}
                                                onChange={(e) => p.setDataEntryForm(prev => ({
                                                    ...prev,
                                                    column_name: e.target.value
                                                }))}
                                                placeholder="e.g., blog_post, article, document"
                                                required
                                                disabled={!!p.editingDataEntry}
                                            />
                                            <small>Database column name (must be valid SQL identifier - letters,
                                                numbers, underscore only)</small>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="schemaVersion">Schema Version:</label>
                                            <input
                                                type="number"
                                                id="schemaVersion"
                                                value={p.dataEntryForm.schema_version}
                                                readOnly
                                                disabled={true}
                                                className="readonly-input"
                                            />
                                            <small>Schema version is automatically managed. It will be incremented from
                                                the database baseline when you commit schema changes.</small>
                                        </div>

                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-secondary" onClick={() => p.setShowDataEntryModal(false)}>
                                        Cancel
                                    </button>
                                    <button className="btn btn-primary" onClick={p.handleSaveDataEntry}>
                                        {p.editingDataEntry ? 'Update' : 'Create'} Data Entry Type
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Update Database Button Section */}
                    {p.hasDataEntryChanges() && (
                        <div className="settings-save-section"
                             style={{marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #e0e0e0'}}>
                            <button
                                className="btn btn-primary btn-save-settings"
                                onClick={p.handleUpdateDatabaseClick}
                                disabled={p.saving || p.dataEntriesLoading}
                            >
                                <i className="fas fa-database"></i> {p.saving ? 'Updating...' : 'Update Database'}
                            </button>
                            <button
                                className="btn btn-secondary"
                                onClick={p.handleDiscardChangesClick}
                                disabled={p.saving || p.dataEntriesLoading}
                                style={{marginLeft: '10px'}}
                            >
                                <i className="fas fa-undo"></i> Discard Changes
                            </button>
                        </div>
                    )}

                    {/* Save Data Settings Button */}
                    <div className="settings-save-section">
                        <button
                            className="btn btn-primary btn-save-settings"
                            onClick={p.handleSaveDataSettings}
                            disabled={!p.hasTabChanges() || p.saving || p.dataSettingsLoading || !p.user?.email}
                        >
                            {p.saving ? (
                                <>
                                    <i className="fas fa-spinner fa-spin"></i> Saving...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-save"></i> Save Data Settings
                                </>
                            )}
                        </button>
                        {p.hasTabChanges() && (
                            <div className="unsaved-changes-indicator">
                                <i className="fas fa-exclamation-circle"></i> You have unsaved changes
                            </div>
                        )}
                    </div>
                </div>
    );
}
